import EarlyExitNoticeWarningBox from './EarlyExitNoticeWarningBox';

export default EarlyExitNoticeWarningBox;
